module.exports = __webpack_public_path__ + "assets/img/sm3.79d229bc.png";